// extracted by mini-css-extract-plugin
var _1 = "styles-module__activitiesTitle___uTHxS";
var _2 = "styles-module__container___woseL";
var _3 = "styles-module__next___luPZ9";
var _4 = "styles-module__previous___rVyG2";
var _5 = "styles-module__riverClass___eyaw4";
var _6 = "styles-module__riverContainer___IxsKr";
export { _1 as "activitiesTitle", _2 as "container", _3 as "next", _4 as "previous", _5 as "riverClass", _6 as "riverContainer" }
